'use client';

import { LinearProgress } from '@mui/material';
import { FC } from 'react';

export const DatagridLinearProgress: FC = () => <LinearProgress data-cy='datagrid-loading-indicator' />;
